import React from "react";

import { getMedCondition } from "../../../../redux/directoryMaintenance/medConditionsReducer/actionsMedConditions";

import GeneralSectionComponent from "../generalSectionComponent";
import MedConditionsModal from "./medConditionsModal/medConditionsModal";

import { MED_CONDITIONS_COLUMNS } from "../../../../components/GeneralComponents/SearchTable/TablesColumns";

function MedConditions() {
  return (
    <GeneralSectionComponent
      title={"Медицинские показания (ограничения)"}
      headerColumns={MED_CONDITIONS_COLUMNS}
      dataFromStateSelector={(state) =>
        state.dictionaryReducer.allMedConditions
      }
      getAction={getMedCondition}
      ModalComponent={MedConditionsModal}
    />
  );
}

export default MedConditions;
